import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Login } from './Login';
import { Logout } from './Logout';
import { SocialRedirect } from './SocialRedirect';
import { RenewModal } from './RenewModal';
import { useLocation } from 'react-router-dom';
import { pickTokensFromSearch } from '../logic/tokens';
export var AuthRoutes = function (_a) {
    var children = _a.children, config = _a.config, authManager = _a.authManager, t = _a.t, container = _a.container, onRedirect = _a.onRedirect, onRenewClose = _a.onRenewClose;
    var location = useLocation();
    var tokens = pickTokensFromSearch(location.search);
    return (React.createElement(React.Fragment, null,
        React.createElement(RenewModal, { authManager: authManager, isModal: true, config: config, t: t, tokens: tokens, onClose: onRenewClose }),
        React.createElement(Switch, null,
            React.createElement(Route, { path: "/oauth2callback", exact: true, component: function () { return React.createElement(SocialRedirect, { t: t }); } }),
            React.createElement(Route, { path: "/login", exact: true, component: function () { return (React.createElement(Login, { config: config, authManager: authManager, t: t, container: container, onRedirect: onRedirect, tokens: tokens })); } }),
            React.createElement(Route, { path: '/logout', exact: true, component: Logout }),
            children)));
};
//# sourceMappingURL=AuthRoutes.js.map